document.addEventListener('plusready', function () {
  var webview = plus.webview.currentWebview();
  plus.key.addEventListener('backbutton', function () {
    webview.canBack(function (e) {
      if (e.canBack && window.location.hash != "#/") {
        if (window.location.hash.indexOf("orderPay/orderPay") > 0) {
          window.location.href = "/";
        } else {
          webview.back();
        }

      } else {
        //webview.close(); //hide,quit
        //plus.runtime.quit();
        //首页返回键处理
        //处理逻辑：1秒内，连续两次按返回键，则退出应用；
        // var first = null;
        var out_time = new_time = 0;
        plus.key.addEventListener('backbutton', function () {
          //首次按键，提示‘再按一次退出应用’
          new_time = new Date().getTime();
          if (out_time != 0 && new_time - out_time <= 1000) {
            out_time = new_time;
            plus.nativeUI.toast("再按一次退出应用", {
              icon: "",// eg. "/img/add.png"
              duration: "short",// 持续3.5s，short---2s
              align: "center",// 水平居中
              verticalAlign: "bottom"// 垂直底部
            });
            // 再按一次退出
          } else {
            // 退出app
            plus.runtime.quit();
          }
          //
          // if (!first) {
          //
          //   // first = new Date().getTime();
          //   // plus.nativeUI.toast("再按一次退出应用", {
          //   //   icon: "",// eg. "/img/add.png"
          //   //   duration: "short",// 持续3.5s，short---2s
          //   //   align: "center",// 水平居中
          //   //   verticalAlign: "bottom"// 垂直底部
          //   // });
          //   // setTimeout(function () {
          //   //   first = null;
          //   // }, 1000);
          // } else {
          //   if (new Date().getTime() - first < 1500) {
          //     plus.runtime.quit();
          //   }
          // }
        }, false);
      }
    })
  });
});



// WEBPACK FOOTER //
// ./src/js/back.js